import { useState } from 'react';

import DatePicker from '@components/date-picker/DatePicker';
import Input from '@components/input/Input';
import Label from '@components/label/Label';
import { formatISODate } from '@utils/date';

interface MemberEndDateProps {
  endDate: string;
  onEndDateChange: (date: string) => void;
  isDisabled?: boolean;
  error?: boolean;
  errorMessage?: string;
}

const MemberEndDate = ({
  endDate,
  onEndDateChange,
  isDisabled,
  error,
  errorMessage
}: MemberEndDateProps) => {
  const [isEndDatePickerVisible, setIsEndDatePickerVisible] =
    useState<boolean>(false);

  return (
    <div className="gap-4">
      <Label label="Fee Collection End Date" />
      <Input
        readOnly
        leftIconName="calendar"
        value={endDate ? formatISODate({ date: endDate }) : ''}
        onClick={() => {
          setIsEndDatePickerVisible(true);
        }}
        placeholder="Select payment end day"
        disabled={isDisabled}
        error={error}
        errorMessage={errorMessage}
        onClearIconAction={() => {
          onEndDateChange('');
        }}
      />
      {isEndDatePickerVisible && (
        <div
          className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 rounded-lg border bg-theme shadow-lg"
          id="end-date-calendar"
        >
          <DatePicker
            confirmButtonLabel="Apply"
            confirmButtonStyle="text-primary"
            handleConfirm={(date: string) => {
              onEndDateChange(date);
              setIsEndDatePickerVisible(false);
            }}
            cancelButtonLabel="Cancel"
            handleCancel={() => {
              setIsEndDatePickerVisible(false);
            }}
            selectedDate={(endDate && new Date(endDate)) || new Date()}
            calendarStyle="!bg-bgBase"
            title="Select End Date"
          />
        </div>
      )}
    </div>
  );
};

export default MemberEndDate;
